<div class="pad-bottom-20">
  <h4>
    @if (!!claimProgressData?.address) {
      <span
        >{{ claimProgressData?.address.addressLine1 }} {{ claimProgressData?.address.city }}
        {{ claimProgressData?.address.state }}</span
      >
    }
    @if (!!(claimProgressData && claimProgressData.lossDescription)) {
      <span>-</span>
    }
    @if (!!claimProgressData) {
      <span>{{ claimProgressData?.lossDescription }}</span>
    }
    @if (!!claimProgressData.lossDetailDescription) {
      <span>,</span>
    }
    @if (!!claimProgressData.lossDetailDescription) {
      <span>{{ claimProgressData?.lossDetailDescription }}</span>
    }
  </h4>
</div>

<div class="row pad-bottom-20">
  <ds-claim-progress-tracker
    [progressData]="claimProgressData"
    [claimType]="claimDetailConstant.PROPERTY"
  ></ds-claim-progress-tracker>
</div>
@if (claim.claimProgress.toUpperCase() !== 'CLOSED') {
  <div class="row">
    <div class="row pad-bottom-20 pad-top-20">
      <div
        class="heading-sub-page bottom-grey-border pad-bottom-20 pad-top-20"
        dsContent
        [contentPath]="'claims.claimActivityText'"
        data-cy="claimStatusActivityText"
      ></div>
      <ds-claim-activity [activityData]="claimActivityData"></ds-claim-activity>
    </div>
    <div class="row pad-top-20">
      <span
        class="heading-sub-page"
        dsContent
        [contentPath]="'claims.claimDetailsText'"
        data-cy="claimStatusDetailsText"
      >
      </span>
    </div>
    <div class="row">
      <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
        <ds-accordion-category [title]="summary" data-cy="claimSummary">
          <ds-claim-status-general
            [claimGeneralData]="claimGeneralData"
            [hasGeneralData]="hasGeneralData"
            [claimType]="claimDetailConstant.PROPERTY"
          ></ds-claim-status-general>
        </ds-accordion-category>
        <ds-accordion-category [title]="payments">
          <ds-claim-status-payments
            [claimPaymentsData]="buildPaymentsData(claim)"
          ></ds-claim-status-payments>
        </ds-accordion-category>
      </ds-accordion>
    </div>
  </div>
} @else {
  <div class="row pad-bottom-20">
    <p dsContent [contentPath]="'claims.completeHeaderText1'"></p>
    <br />
    <p dsContent [contentPath]="'claims.completeHeaderText2'"></p>
  </div>
  <div class="row pad-top-20 pad-bottom-20 bottom-grey-border">
    <span
      class="heading-sub-page"
      dsContent
      [contentPath]="'claims.claimDetailsText'"
      data-cy="claimStatusDetailsText"
    >
    </span>
  </div>
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.propertyText'"></b></div>
    <div class="float-right">
      @if (claimGeneralData?.lossLocationAddress?.addr1) {
        <span>{{ claimGeneralData?.lossLocationAddress?.addr1 }} <br /> </span>
      }
      <span>{{
        claimGeneralData?.lossLocationAddress?.city +
          ', ' +
          claimGeneralData?.lossLocationAddress?.state +
          ' ' +
          claimGeneralData?.lossLocationAddress?.zip5
      }}</span>
    </div>
  </div>
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.policyText'"></b></div>
    <div class="float-right">{{ claimGeneralData.policyNumber | prettyPolicyNum }}</div>
  </div>
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.statusText'"></b></div>
    @if (!!claim?.closedDate) {
      <div class="float-right">Closed on {{ claim?.closedDate | date: 'shortDate' }}</div>
    }
    @if (!claim?.closedDate) {
      <div class="float-right"><span dsContent [contentPath]="'shared.closed'"></span></div>
    }
  </div>
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left">
      <b dsContent [contentPath]="'claims.dateAndTimeIncidentText'"></b>
    </div>
    <div class="float-right">
      <span>{{ claimGeneralData.incidentDate }}</span> <br />
      <span>{{ claimGeneralData.timeOfIncident }}</span>
    </div>
  </div>
  @if (claimGeneralData?.claimDescription) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left">
        <b dsContent [contentPath]="'claims.incidentDescriptionText'"></b>
      </div>
      <div class="float-right">{{ claimGeneralData?.claimDescription }}</div>
    </div>
  }
  <div class="row pad-top-20 pad-bottom-20 bottom-grey-border">
    <span
      class="heading-sub-page"
      dsContent
      [contentPath]="'claims.claimContactText'"
      data-cy="claimContactText"
    >
    </span>
  </div>
  @if (claim?.primaryFileHandler) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left"><b dsContent [contentPath]="'claims.adjusterText'"></b></div>
      <div class="float-right">
        {{ claim.primaryFileHandler.firstName }} {{ claim.primaryFileHandler.lastName }}
      </div>
    </div>
  }
  <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
    <div class="float-left"><b dsContent [contentPath]="'claims.phoneText'"></b></div>
    @if (claim?.primaryFileHandler?.phones?.length > 0) {
      <div class="float-right">
        {{ claim.primaryFileHandler.phones[0].areaCode }}-{{
          claim.primaryFileHandler.phones[0].number
        }}
        {{
          claim.primaryFileHandler.phones[0].extension
            ? 'ext. ' + claim.primaryFileHandler.phones[0].extension
            : ''
        }}
      </div>
    }
    @if (claim?.primaryFileHandler?.phones?.length === 0) {
      <div class="float-right">
        {{ amfamPhone }}
      </div>
    }
  </div>
  @if (claim?.primaryFileHandler?.emails?.length > 0) {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left"><b dsContent [contentPath]="'claims.emailText'"></b></div>
      <div class="float-right">{{ claim.primaryFileHandler.emails[0].emailAddress }}</div>
    </div>
  }
}
